(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bog-parallax"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bog-parallax')) {
    customElements.define('bog-parallax', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mounted !== 'true') {
          const target = document.querySelector('#zap-beginner');
          const wrapper = this.closest('.shopify-section');
          const id = this.dataset.instance || 'bog';
          const existing = document.querySelector(`[data-bog-clone="${id}"]`);

          if (target && !existing) {
            const clone = this.cloneNode(true);
            clone.dataset.mounted = 'true';
            clone.dataset.bogClone = id;
            target.parentNode.insertBefore(clone, target);
          }

          if (wrapper) wrapper.style.display = 'none';
          return;
        }

        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;

        const desktopMouse = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const mm = 96 / 25.4;
        const mouseAmount = Number(this.dataset.mouse || 0) * mm;
        const scrollAmount = Number(this.dataset.scroll || 0) * mm;
        let pointerX = 0;
        let pointerY = 0;
        let frame = 0;

        const clamp = n => Math.max(-1, Math.min(1, n));

        const update = () => {
          frame = 0;
          const rect = this.getBoundingClientRect();
          const scrollProgress = clamp((innerHeight / 2 - (rect.top + rect.height / 2)) / ((innerHeight + rect.height) / 2));
          const px = reduced.matches ? 0 : pointerX * mouseAmount;
          const py = reduced.matches ? 0 : pointerY * mouseAmount;
          const sy = reduced.matches ? 0 : scrollProgress * scrollAmount;

          this.querySelectorAll('[data-speed]').forEach(layer => {
            const speed = Number(layer.dataset.speed || 1);
            layer.style.setProperty('--x', `${px * speed}px`);
            layer.style.setProperty('--y', `${(py + sy) * speed}px`);
          });
        };

        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(update);
        };

        this.addEventListener('pointermove', event => {
          if (!desktopMouse.matches || event.pointerType !== 'mouse') return;
          const rect = this.getBoundingClientRect();
          pointerX = clamp(((event.clientX - rect.left) / rect.width) * 2 - 1);
          pointerY = clamp(((event.clientY - rect.top) / rect.height) * 2 - 1);
          schedule();
        }, { passive: true, signal });

        this.addEventListener('pointerleave', () => {
          pointerX = 0;
          pointerY = 0;
          schedule();
        }, { signal });

        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });

        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this);
        schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
